<!----
    Author: hjlee
    Description:
        비밀번호 변경 모달
---->
<template>
  <b-modal
    id="modal"
    ref="modalRef"
    :title="$t('change_password_modal.title.change_password')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    :ok-disabled="!oldPassword || !newPassword || newPassword !== newPasswordConfirm"
    @ok="confirm"
  >
    <input-control
      v-model="oldPassword"
      :modal-name="modalName"
      name="old_password"
      type="password"
      required
    />
    <input-control
      v-model="newPassword"
      :modal-name="modalName"
      rules="password"
      name="new_password"
      type="password"
      required
    />
    <input-control
      v-model="newPasswordConfirm"
      :modal-name="modalName"
      :rules="'password_confirm:' + newPassword"
      name="new_password_confirm"
      type="password"
      required
    />
  </b-modal>
</template>

<script>
export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      modalName: 'change_password_modal'
    }
  },
  methods: {
    confirm: function(evt) {
      let userId = this.userId
      if (!userId) {
        userId = this.loggedInUser.userId
      }
      evt.preventDefault()
      if (this.newPassword !== this.newPasswordConfirm) {
        this.$toast.info(this.$t('validation.message.password_confirm'))
        return
      }
      if (this.newPassword === this.oldPassword) {
        this.$toast.info(this.$t('validation.message.password_same'))
        return
      }
      this.$axios
        .$post('/auth/public/changePassword', {
          id: this.loggedInUser.id,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          locale: localStorage.locale
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.hideModal('modalRef')
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    }
  }
}
</script>
